import { useRef, useState } from 'react'
import { useClickOutside } from '~/hooks/useClickOutside'
import { Button } from '~/components/general/Button'

import { MailIcon } from '~/components/icons'
import { trackEvent } from '~/utils/tracking'

interface Props {
  articleId: string | undefined
  articleTitle: string | undefined
  articleAbstract: string | undefined
}

const FormStates = {
  validationError: 'validationError',
  serverError: 'serverError',
  sent: 'sent',
  sending: 'sending',
}

export const Email = ({ articleId, articleTitle, articleAbstract }: Props) => {
  const ref = useRef<HTMLDivElement>(null)
  const [isOpened, setIsOpened] = useState(false)
  const [email, setEmail] = useState('')
  const [state, setState] = useState('')

  useClickOutside(ref, () => {
    if (state === FormStates.sent) {
      setState('')
    }
    setIsOpened(false)
  })

  const ValidateEmail = (email: string) => {
    // eslint-disable-next-line no-useless-escape
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return true
    }
    setState(FormStates.validationError)
    return false
  }

  const handleSendEmail = async () => {
    trackEvent('send_blog', {
      email,
      blog_id: articleId ?? '',
    })
    if (ValidateEmail(email)) {
      setState(FormStates.sending)
      const res = await fetch(`/api/app/blog-emails`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          blog_title: articleTitle,
          blog_description: articleAbstract,
          blog_url: window?.location?.href,
        }),
      })
      if (res.status === 200) {
        setEmail('')
      }
      setState(FormStates.sent)
    }
  }

  return (
    <li className="list-none [&:not(:last-child)]:mr-2">
      {isOpened && (
        <div
          className="absolute pt-8 px-8 pb-6 bg-white z-2 rounded-3xl"
          style={{
            top: '-70px',
            boxShadow:
              '0px 6px 8px -2px rgba(15, 56, 113, 0.02), 0px 16px 64px -8px rgba(15, 56, 113, 0.18)',
            width: '480px',
            minHeight: '228px',
          }}
          ref={ref}
        >
          <p className="text-m">
            {state === FormStates.validationError && `Hmm... that email doesn't look valid`}
            {state === FormStates.sent && (
              <>
                Message sent successfully. <br />
                Please check your email.
                <img className="block mt-5" alt="" src={`/images/email-sent.png`} />
              </>
            )}
            {state === '' && `Send Me This!`}
          </p>
          {state !== FormStates.sent && (
            <>
              <input
                onChange={(e) => {
                  setEmail(e.target.value)
                }}
                name="email"
                className="placeholder:text-neutral-40 placeholder:opacity-100 max-lg:pl-4 max-lg:h-12 max-md:w-auto flex flex-col justify-center p-0 gap-2 w-auto h-13 rounded-lg flex-none flex-grow caret-blue-50 pl-5 text-neutral-100 text-s outline-none border-neutral-15 bg-white isolate font-tt_talent"
                style={{ marginTop: '20px', marginBottom: '12px', width: '100%' }}
              />

              <Button
                text={'Submit'}
                disabled={state === 'sending'}
                onClick={handleSendEmail}
                className={'w-fit'}
              />
            </>
          )}
        </div>
      )}
      <div
        className="max-md:w-15 max-md:h-15 flex items-center justify-center w-17 h-17 rounded-[50%] bg-neutral-5 hover:bg-neutral-10"
        onClick={() => {
          setIsOpened((isOpened) => !isOpened)
        }}
        rel="noreferrer"
      >
        <MailIcon />
      </div>
    </li>
  )
}
